<template>

    <div class="">
        
        <v-form
           id="nodeform"
           ref="form"
           v-model="valid"
           :lazy-validation="lazy">

            <!-- CARD ACTIONS -->

            <v-toolbar
              flat
              style="border-bottom:2px solid #ddd"              
              >
        
                <v-toolbar-title>Verantworliche/n bearbeiten</v-toolbar-title>
                  
                    <v-checkbox
                    v-model="node.published"
                    label="Veröffentlicht"
                    dense
                    class="check-published"
                    ></v-checkbox>
                  
                  <v-spacer></v-spacer>                    

                    <v-btn class="mr-4"
                    v-if="node.id"
                    :disabled="!valid"
                    @click="formSubmit"
                    style="display:inline-block"
                    >Aktualisieren</v-btn>

                    <v-btn class="mr-4"
                    v-else
                    :disabled="!valid"
                    @click="formSubmit"
                    style="display:inline-block"
                    >Speichern</v-btn>

                    <v-btn-toggle                        
                      borderless                    
                      dense    
                      class="mr-2"
                      >
                      <v-btn      
                        icon
                        :to="'/'+$home+'content/'+nodetype"
                        >      
                        <v-icon>mdi-table-of-contents</v-icon>
                      </v-btn>

                      <v-btn 
                        class="small" 
                        value="right" 
                        :to="'/'+$home+'p/'+nodetype+'/'+nodeid" 
                        target="_blank" 
                        v-if="nodetype === 'usecase' || nodetype === 'testfield'"
                        >
                        <span class="hidden-sm-and-down">Preview</span>
                        <v-icon right>
                          mdi-open-in-new
                        </v-icon>
                      </v-btn>

                      <v-btn 
                        class="small" 
                        value="right" 
                        :to="'/panorama/?q='+nodeid" 
                        target="_blank" 
                        v-if="nodetype === 'pano'"
                        >
                        <span class="hidden-sm-and-down">Preview</span>
                        <v-icon right>
                          mdi-open-in-new
                        </v-icon>
                      </v-btn>

                    </v-btn-toggle>
  
            </v-toolbar>

            <!-- / CARD ACTIONS --->

            <!-- Alert info -->
            <v-alert
              v-model="alertshow"
              border="left"
              class="alertred"
              close-text="Close Alert"          
              dismissible
            ><p>
              {{  alertmessage }}
            </p>
            </v-alert>

              
          <v-row class="nodecontent">

               <v-col cols="7" sm="7" >

                    <v-text-field
                      v-model="node.name"
                      :counter="200"
                      :rules="nameRules"
                      label="Name"
                      background-color="#f7f7f7"
                      required
                      color="#333333"
                      height=auto
                      class="my-5 py-2"
                    ></v-text-field>

                    <v-row>
                      <v-col cols="12" style="padding:10px 16px 40px;">

                        <v-autocomplete
                          v-model="node.ldap_id"                  
                          :search-input.sync="search"
                          @keyup="onChangeUser(search)"
                          @input="setUser(node.ldap_id)"
                          :items="users"
                          item-value="ldap_id"
                          item-text="fullname"
                          label="Verantworliche Person in TH-Datensätzen suchen"
                          class="mt-5 mb-0 py-2"
                          background-color="#f7f7f7"
                          required
                          >
                          <template v-slot:item='{item}'> <div v-html='item.fullname'/> </template>
                          <template v-slot:selection='{item}'> <div v-html='item.fullname'/></template>
                        </v-autocomplete>

                        <v-row v-if="account">
                          <v-col cols="6">
                            <p>Aktuelle Mitarbeiterdaten:</p>
                            <div>
                              <div>Name: {{ account.fullname }} </div>
                              <div>Type: {{ account.type }}</div>
                              <div>Group: {{ account.group }}</div>
                              <div>Tel: {{ account.telephone }}</div>
                              <div>Office: {{ account.office }}</div>
                              <div>Email: {{ account.email }}</div>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="text-align: right;">
                              <img :src="account.image" alt="" />
                            </div>
                          </v-col>                            
                        </v-row>

                        <v-text-field
                            v-model="node.ldap_id"                                                                             
                            label="ldap id"
                            background-color="#f7f7f7"
                            required
                            color="#333333"
                            height=auto
                            class="my-5 py-2"
                          ></v-text-field>

                      </v-col>
                    </v-row>

                    <v-text-field
                      v-model="node.id"
                      type="hidden"
                    ></v-text-field>

                     <v-btn class="mr-4"
                      v-if="node.id"
                      :disabled="!valid"
                     @click="formSubmit"
                     >Aktualisieren</v-btn>

                     <v-btn class="mr-4"
                      v-else
                      :disabled="!valid"
                     @click="formSubmit"
                     >Speichern</v-btn>

               </v-col>

               <v-col cols="5" sm="5" >
                <div class="txtwrap">
                  <v-subheader>Zusätzl. Kontaktdaten (optional)</v-subheader>
                  <vue-editor
                    :editorOptions="editorSettings"
                    useCustomImageHandler
                    @image-added="handleImageAdded"
                    v-model="node.contact" />

                    <v-text-field
                     v-model="node.organisation"
                     :counter="200"
                     :rules="lengthRules"
                     label="Institution"
                     background-color="#f7f7f7"
                     required
                     color="#333333"                     
                     height=auto
                     class="my-5 py-2"
                   ></v-text-field>

                   <v-text-field
                     v-model="node.department"
                     :counter="200"
                     :rules="lengthRules"
                     label="Bereich"
                     background-color="#f7f7f7"
                     required
                     color="#333333"
                     height=auto
                     class="my-5 py-2"
                   ></v-text-field>

                   <v-select
                      v-model="node.category"
                      :items="categories"
                      :rules="[v => !!v || 'Kategorie ist erforderlich']"
                      item-value="id"
                      label="Kategorie"
                      required
                      class="my-1 py-1"
                      >
                      <template v-slot:item='{item}'> <span v-html="item.name + '|' + item.id"></span> </template>
                      <template v-slot:selection='{item}'> <span v-html="item.name + '|' + item.id"></span> </template>
                    </v-select>

                </div>
               </v-col>

        </v-row>

        </v-form>

    </div>

</template>

<script>

    //import Quill from 'quill';
    //import { ImageDrop } from 'quill-image-drop-module';
    //import ImageResize from 'quill-image-resize-module';
    //Quill.register('modules/imageDrop', ImageDrop);
    //Quill.register('modules/imageResize', ImageResize);

    export default {
        name: 'FieldContent',
        data() {
          return {
            alertshow: false,
            alertmessage: 'Die eingetragene Profil-ID ist schon vorhanden.',
            search: null,
            users: [],
            account: null,
            editorSettings: {
                modules: {
                  imageDrop: true,
                  imageResize: true
                }
            },
            componentKey: 0,
            published: false,
            errors: [],
            valid: true,                
            imgFile: null,
            resps: [],
            previewsrc: null,
            categories: [
              {
                id: 1,
                name: 'Verantwortliche/r'
              },
              {
                id: 2,
                name: 'Scout'
              },
              {
                id: 3,
                name: 'Testbed'
              },                  
            ],
            nodeRespRef: null,
            nameRules: [
              v => !!v || 'Name erforderlich',
              v => (v && v.length <= 200) || 'Name darf max. 200 Zeichen enthalten',
            ],
            lengthRules: [
              v => (!v || (v && v.length <= 200)) || 'Name darf max. 200 Zeichen enthalten',
            ],                
            lazy: false
          };
        },
        props: {
          nodetype: {
            type: String
          },
          node: {
              type: Object,
              default: () => ({
                category: 1
              })
          }
        },
        components: {
        },
        methods: {
          checkForm (data) {
            console.log(data);
          },
          validate () {
            this.$refs.form.validate()
          },
          reset () {
            this.$refs.form.reset()
          },
          resetValidation () {
            this.$refs.form.resetValidation()
          },
          onChangeResponsibility(e){
            this.nodeRespRef = this.resps.find(resp => resp.id === e);
            this.componentKey += 1;
          },
          setUser (user) {
            const self = this            
            this.axios.get( this.$config.host + '/accountinfo/' + user )
              .then(result => {                  
                if(result.data && result.data.length > 0) {
                  self.account = result.data[0]
                }
              })
              .catch(err => {
                console.log(err);
              })
          },
          input (e) {
            console.log('input!');
            console.log(e);
          },
          onChangeUser(search) {
            console.log('onChangeUser');
            const self = this
            this.axios.get( this.$config.host + '/accountinfo/' + search )
              .then(result => {                  
                self.users = result.data
              })
              .catch(err => {
                console.log(err);
              });          
          },
          onInitUser(search) {
            const self = this
            this.axios.get( this.$config.host + '/accountinfo/' + search )
              .then(result => {
                if(result && result.data.length > 0) {
                  self.node.ldap_id = result.data[0].ldap_id
                  self.account = result.data[0]
                }
              })
              .catch(err => {
                console.log(err);
              });          
          },          
          readURL() {
              var self = this;
              if (this.imgFile) {
                  var reader = new FileReader();
                  reader.onload = function (e) {
                      self.previewsrc = e.target.result;
                  }
                  reader.readAsDataURL(this.imgFile);
              } else {
                this.imgfile = self.previewsrc;
              }
          },          
          onChangeFileUpload() {            
            this.readURL();
          },          
          handleImageAdded(file, Editor, cursorLocation, resetUploader) {

              var formData = new FormData();
              formData.append("image", file);

              var self = this;

              this.axios.post( this.$config.host+"/image", formData)
                .then(result => {

                  if(result.data == "max") {

                      self.$toasted.error('Datei leider zu groß');

                  } else {

                      let url = self.$config.imagepath + result.data.name;
                      Editor.insertEmbed(cursorLocation, "image", url);
                      resetUploader();

                  }

                })
                .catch(err => {
                  console.log(err);
                });
          },
          formSubmit() {              
              const config = { headers: { 'Content-Type': 'multipart/form-data' } };

              const formData = new FormData();
              formData.set('name', this.node.name);
              formData.set('contact', this.node.contact ? this.node.contact : '');
              formData.set('organisation', this.node.organisation ? this.node.organisation : '');
              formData.set('department', this.node.department ? this.node.department : '');
              formData.set('category', this.node.category ? this.node.category : 0);
              formData.set('published', this.node.published);
              formData.set('process', this.node.id ? 'update' : 'generate');
              formData.set('ldap_id', this.node.ldap_id ? this.node.ldap_id : null);
              formData.set('id', this.node.id ? this.node.id : null);
              formData.set('src', this.node.src ? this.node.src : null);
              formData.append('file', this.imgFile);

              // Was ist das hier??              
              let self = this;

              this.axios.post( this.$config.host+"/resp", formData, config)
              .then(function (response) {
                  if(response.data !== 'error') {
                    self.$router.push({path: '/'+self.$home+'content/resp'});
                    self.$emit('respsaved', null)
                  } else {
                    self.alertshow = true;
                  }
              })
              .catch(function (error) {
                  self.output = error;
              });
          },
          getResps() {
              this.axios.get( this.$config.host+"/resps" ).then(response => (
                this.resps = response.data,
                console.log("respsContent: resps Referenzen erhalten:"),
                console.log(this.resps)
              ));
          }
        },
        created() {
            //this.getResps();
        },
        computed: {
            editor() {
              return this.$refs.myQuillEditor.quill
            }
        },
        mounted() {
          if(Object.keys(this.node).length < 1) {
            this.node.category = 1;
            this.node.organisation = 'TH Wildau'
          }
        },
        watch: {
          node: function (values) {
            this.node = values;
            if(this.node.ldap_id) {
              this.onInitUser(this.node.ldap_id);
            }
            if(this.previewsrc == null) {
                this.previewsrc =  this.node.pathimg ? this.node.pathimg : null;
            }
          }
        }        
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.form-wrap {
  margin:30px 0;
}
#nodeform .v-subheader {
  padding-left:0;
  padding-right:0;
}
#nodeform .v-label {
  color:#666666;
}
.txtwrap {
  padding: 10px 0;
  margin: 0px 0;
}
.preview {
  display:block;
  max-height:500px;
  max-width:100%;
}
.selecticon {
  height:20px;
  width: auto;
  margin-right:20px;
}
.ck-editor__editable {
  min-height: 300px;
}

.ql-container {
  font-size:1rem;
}
.ql-editor .ql-video {
  width:100%;
  height:450px;
}

</style>
